import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.to-reversed.js";
import "core-js/modules/es.array.to-sorted.js";
import "core-js/modules/es.array.to-spliced.js";
import "core-js/modules/es.array.with.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.map.group-by.js";
import "core-js/modules/es.object.group-by.js";
import "core-js/modules/es.promise.with-resolvers.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.string.is-well-formed.js";
import "core-js/modules/es.string.to-well-formed.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.immediate.js";
import "core-js/modules/web.structured-clone.js";
import "core-js/modules/web.url.can-parse.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ErrorBoundary, Provider as RollbarProvider } from '@rollbar/react';
import React from 'react';
import { Helmet } from 'react-helmet';
import { defaultMetadata, getSocialMetadata } from '../lib/page-metadata.js';
import { homepageCanonical } from './config/homepage-content.js';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import '../public/index.css';
import { createRoot } from 'react-dom/client';
import colors from './colors';
import GlobalStyles from './design/GlobalStyles';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import { store } from './store';
import { followCanonicalHost } from './util/canonicalHost';
import { seoHead } from './config/seoBasics.js';

// TEAMBRIDGE_SEO_BASICS: the search title, description and og tags the server put in the homepage's and
// /pricing's HTML stay after the app loads (src/config/seoBasics.js); without the server's marker, nothing changes.
const seoOg = seo => [['og:title', seo.ogTitle || seo.title], ['og:description', seo.description], ['og:type', 'website'], ['og:site_name', 'TeamBridge'], ...(seo.url ? [['og:url', seo.url]] : [])];
function SocialMetadata() {
  const {
    pathname
  } = useLocation();
  const seo = seoHead(pathname);
  return /*#__PURE__*/React.createElement(Helmet, null, pathname === '/' && /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: homepageCanonical
  }), Object.entries(getSocialMetadata(pathname)).map(([property, content]) => /*#__PURE__*/React.createElement("meta", {
    key: property,
    property: property,
    content: content
  })), seo && /*#__PURE__*/React.createElement("title", null, seo.title), seo && /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: seo.description
  }), seo && seoOg(seo).map(([property, content]) => /*#__PURE__*/React.createElement("meta", {
    key: property,
    property: property,
    content: content
  })));
}
const theme = createTheme({
  typography: {
    fontFamily: ['Poppins', "'Poppins Fallback'", 'sans-serif'].join(',')
  },
  palette: {
    primary: {
      main: colors.text.primary
    }
  }
});
const rollbarConfig = {
  accessToken: '67a1a576714d4fb3a13e6ced55ada512',
  environment: ENVIRONMENT
};

// Only the production hosts send analytics, like PostHog in public/index.html (local, preview and review apps don't).
// mixpanel-browser (~65 KB) loads after the page has, not with it.
if (['teambridge.app', 'www.teambridge.app'].includes(window.location.hostname)) {
  window.addEventListener('load', () => {
    import(/* webpackChunkName: "mixpanel" */'mixpanel-browser').then(({
      default: mixpanel
    }) => mixpanel.init('12e898ad7de5d604a3ad98ebbfffe197')).catch(() => {});
  }, {
    once: true
  });
}
const container = document.getElementById('root');
const root = createRoot(container);
root.render(/*#__PURE__*/React.createElement(RollbarProvider, {
  config: rollbarConfig
}, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(ThemeProvider, {
  theme: theme
}, /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(Provider, {
  store: store
}, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, defaultMetadata.title), /*#__PURE__*/React.createElement("meta", {
  name: "description",
  content: defaultMetadata.description
})), /*#__PURE__*/React.createElement(SocialMetadata, null), /*#__PURE__*/React.createElement(GlobalStyles, null), /*#__PURE__*/React.createElement(App, null)))))));
serviceWorker.unregister();
// TEAMBRIDGE_CANONICAL_HOST: keep the head's canonical tags on the host the server marked.
followCanonicalHost();